import React from "react";
import styled from 'styled-components'
import { FacebookShareButton, FacebookIcon, TwitterShareButton, TwitterIcon } from "react-share";
import { ArticleSharingMethod, useRecordArticleShared } from "hooks/analytics/useRecordArticleShared";

const ShareLinkButtonsContainer = styled.div.attrs({
	className: "flex items-center justify-center py-2"
})``;

const ShareButtonContainer = styled.div.attrs({ className: "m-1 cursor-pointer" })``;

export default ({ link, story }: { link: string, story?: any }) => {

	const recordArticleShared = useRecordArticleShared()

	return (
    <ShareLinkButtonsContainer>
      <ShareButtonContainer>
        <FacebookShareButton
          beforeOnClick={() => {
            if(story) {
              recordArticleShared(story, ArticleSharingMethod.facebook);
            }
          }}
          url={link}
        >
          <FacebookIcon size={32} round />
        </FacebookShareButton>
      </ShareButtonContainer>
      <ShareButtonContainer>
        <TwitterShareButton
          beforeOnClick={() => {
            if(story) {
              recordArticleShared(story, ArticleSharingMethod.twitter);
            }
          }}
          url={link}
        >
          <TwitterIcon size={32} round />
        </TwitterShareButton>
      </ShareButtonContainer>
    </ShareLinkButtonsContainer>
  );
}
